
// ============================================
// REQUEST QUOTE MODAL - JAVASCRIPT
// ============================================

// Funktion zum Öffnen des Modals
function openRequestModal(productName) {
    console.log("Opening Modal for:", productName);
    var modal = document.getElementById("request-quote-modal");
    var messageBox = document.getElementById("request-message-text");

    if (modal) {
        modal.style.display = "flex";
        if (messageBox && productName) {
            // Nur setzen wenn leer oder Standardtext
            if (!messageBox.value || messageBox.value.includes("Hallo Griddle-Grills-Team")) {
                messageBox.value = "Hallo Griddle-Grills-Team,\n\nich interessiere mich für " + productName + ".";
            }
        }
    }
}

// Funktion zum Schließen des Modals
function closeRequestModal() {
    var modal = document.getElementById("request-quote-modal");
    if (modal) {
        modal.style.display = "none";
    }
}

// Schließen beim Klick außerhalb
window.onclick = function (event) {
    var modal = document.getElementById("request-quote-modal");
    if (event.target == modal) {
        modal.style.display = "none";
    }
}

// ============================================
// AGGRESSIVE BUTTON REPLACEMENT LOGIC
// For Collection/Category Pages (Boost AI & GemPages)
// ============================================

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(initRequestButtons, 500);
    setTimeout(initRequestButtons, 1500);
    setTimeout(initRequestButtons, 3000);
    setInterval(initRequestButtons, 2500);

    var targetNode = document.body;
    if (targetNode) {
        var observer = new MutationObserver(function (mutations) {
            initRequestButtons();
        });
        observer.observe(targetNode, { childList: true, subtree: true });
    }
});

function initRequestButtons() {
    // PART 1: Standard Containers
    var productItems = document.querySelectorAll(
        '.boost-sd__product-item, .boost-sd_product-item, .grid__item, .product-card-wrapper, ' +
        '.gp-product-item, .gf_product-block, .gf_row, [data-gempages-product]'
    );

    productItems.forEach(function (item) {
        var isSoldOut = false;

        // 1. Badge/Label Check
        var label = item.querySelector('.boost-sd__product-label, .card__badge, .badge, .boost-sd__flag, .gf_product-badge');
        if (label) {
            var labelText = label.innerText.trim().toLowerCase();
            if (labelText.includes('sold out') || labelText.includes('ausverkauft') || labelText.includes('nicht vorrätig') || labelText.includes('out of stock')) {
                isSoldOut = true;
            }
        }

        // 2. Class on item
        if (item.classList.contains('boost-sd__product-item--sold-out')) {
            isSoldOut = true;
        }

        // 3. Button Check
        var btn = item.querySelector(
            '.boost-sd__product-atc, .quick-add__submit, button[name="add"], .boost-sd__product-btn, ' +
            '.product-form__submit, .boost-sd__button, .gf_add-to-cart, .gf_button, [data-add-to-cart]'
        );

        if (btn) {
            var btnText = btn.innerText.trim().toLowerCase();
            if (btn.disabled || btnText.includes('sold out') || btnText.includes('ausverkauft') ||
                btnText.includes('nicht vorrätig') || btnText.includes('unavailable') || btnText.includes('out of stock')) {
                isSoldOut = true;
            }
        }

        if (isSoldOut && btn) {
            transformButton(btn, item);
        }
    });

    // PART 2: Global Search (GemPages etc)
    var allButtons = document.querySelectorAll('button, a.button, a.btn, .gf_button, .gf_add-to-cart, [role="button"], .btn, input[type="submit"]');

    allButtons.forEach(function (btn) {
        var btnText = btn.innerText.trim().toLowerCase();

        if (btnText.includes('sold out') || btnText.includes('ausverkauft') ||
            btnText.includes('nicht vorrätig') || btnText.includes('out of stock') ||
            btnText.includes('unavailable')) {

            // Try to assume parent
            var parentItem = btn.parentElement;
            transformButton(btn, parentItem);
        }
    });
}

// ============================================
// BUTTON TRANSFORMATION FUNCTION
// ============================================
function transformButton(btn, parentItem) {
    if (btn.getAttribute('data-request-btn') === 'true') return;
    btn.setAttribute('data-request-btn', 'true');

    var newBtn = btn.cloneNode(true);

    newBtn.removeAttribute('disabled');
    newBtn.removeAttribute('name');
    if (newBtn.tagName === 'INPUT') {
        var tempBtn = document.createElement('button');
        tempBtn.className = newBtn.className;
        newBtn = tempBtn;
    }

    newBtn.setAttribute('type', 'button');
    newBtn.classList.remove('disabled');
    newBtn.classList.remove('boost-sd__button--disabled');
    newBtn.classList.add('btn-request-green');

    newBtn.innerText = "Verfügbarkeit anfragen";

    newBtn.style.cssText =
        "background-color: #5E8E49 !important; " +
        "color: white !important; " +
        "opacity: 1 !important; " +
        "visibility: visible !important; " +
        "display: inline-flex !important; " +
        "align-items: center !important; " +
        "justify-content: center !important; " +
        "width: 100% !important; " +
        "cursor: pointer !important; " +
        "pointer-events: auto !important; " +
        "text-decoration: none !important;";

    if (btn.parentNode) {
        btn.parentNode.replaceChild(newBtn, btn);
    }

    // --- EVENT LISTENER WITH FULL RADAR SEARCH ---
    newBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var pName = '';
        var foundTitle = false;

        // Strategy: Traverse UP the DOM tree (up to 7 levels)
        var currentElement = newBtn;
        for (var i = 0; i < 7; i++) {
            if (!currentElement) break;

            var scope = currentElement.parentElement;
            if (!scope) break;

            if (scope.tagName === 'BODY' || scope.id.includes('MainContent') || scope.classList.contains('page-width')) break;

            // 1. Look for Title Classes/Tags in this scope
            // ADDED h1 and h1 classes for PRODUCT PAGE support
            var titleEl = scope.querySelector(
                '.boost-sd__product-title, .card__heading, .gp-product-title, .gf_product-title, ' +
                '.product-card__title, .product-title, .product__title, .title, .h0, .h1, .h2, h1, h2, h3, h4, [class*="title"], [class*="name"]'
            );

            // 2. Look for Links to Products (High priority for grids)
            if (!titleEl && !foundTitle) {
                var links = scope.querySelectorAll('a[href*="/products/"]');
                var bestLink = '';
                links.forEach(function (l) {
                    if (l === newBtn || l.classList.contains('btn-request-green')) return;
                    var txt = l.innerText.trim();
                    if (txt.length > bestLink.length && txt.toLowerCase() !== 'view') {
                        bestLink = txt;
                        titleEl = l;
                    }
                });
            }

            // 3. Look for Headers (Generic)
            if (!titleEl && !foundTitle) {
                var headers = scope.querySelectorAll('h1, h2, h3, h4, h5');
                for (var k = 0; k < headers.length; k++) {
                    if (headers[k].innerText.trim().length > 3) {
                        titleEl = headers[k];
                        break;
                    }
                }
            }

            // Did we find it?
            if (titleEl && titleEl.innerText.trim().length > 0) {
                pName = titleEl.innerText.trim();
                break; // Found it!
            }

            // Move up for next iteration
            currentElement = scope;
        }

        // --- GLOBAL FALLBACK (CRITICAL FOR PRODUCT PAGE) ---
        // If radar failed OR returned generic/empty result, AND we are on a product page.
        // We check if the URL contains '/products/' to confirm we are on a PDP.
        if ((!pName || pName === 'Produkt') && window.location.href.indexOf('/products/') > -1) {
            var globalTitle = document.querySelector('h1.product__title, .product-single__title, h1');
            if (globalTitle) {
                pName = globalTitle.innerText.trim();
            }
        }

        openRequestModal(pName || "Produkt");
    });
}
